<div
  id="kuba-navigation"
  class="app-sidemenu"
  [class.kuba-nav-open]="navigation.expanded()"
  [attr.role]="navigation.mobileOpen() ? 'dialog' : null"
  [attr.aria-modal]="navigation.mobileOpen() ? 'true' : null"
  [attr.aria-label]="'NAVIGATION' | translate"
  [attr.inert]="navigation.mobile() && !navigation.mobileOpen() ? '' : null"
  [cdkTrapFocus]="navigation.mobileOpen()"
  (keydown.escape)="navigation.closeMobile()"
  (scroll)="closeSubNavigation()"
>
  @if (navigation.mobile()) {
    <div class="kuba-nav-header">
      <span>{{ "NAVIGATION" | translate }}</span>
      <button
        type="button"
        class="kuba-icon-button"
        id="kuba-navigation-close"
        [attr.aria-label]="'CLOSE' | translate"
        (click)="navigation.closeMobile()"
      >
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>
  }
  <nav
    class="sidemenu-wrapper"
    [attr.aria-label]="'NAVIGATION' | translate"
    [attr.aria-busy]="placeholder"
  >
    @if (placeholder) {
      <div class="kuba-nav-skeleton" aria-hidden="true">
        @for (row of [1, 2, 3, 4, 5, 6, 7, 8]; track row) {
          <div class="kuba-nav-skeleton-row"><span></span><span></span></div>
        }
      </div>
    } @else {
      <ul class="sidemenu-links">
        @for (feature of features; track feature.id) {
          <li
            class="link-item"
            routerLinkActive="active"
            (mouseenter)="onModuleMouseEnter(feature, $event)"
            (mouseleave)="scheduleSubNavigationClose()"
            (focusin)="onModuleFocusIn(feature, $event)"
            (focusout)="onModuleFocusOut($event)"
          >
            <a
              [routerLink]="urlBase + '/' + feature.linkText"
              routerLinkActive="kuba-nav-current"
              ariaCurrentWhenActive="page"
              [attr.aria-label]="navLabelKey(feature) | translate"
              [attr.aria-haspopup]="subNavigationFor(feature) ? 'true' : null"
              [attr.aria-expanded]="
                subNavigationFor(feature)
                  ? subNavigation()?.feature === feature
                  : null
              "
              (click)="setCurrentModule(feature)"
              (keydown.arrowright)="focusSubNavigation($event)"
              (keydown.escape)="closeSubNavigation()"
              [pTooltip]="navLabelKey(feature) | translate"
              [tooltipDisabled]="
                navigation.expanded() || !!subNavigationFor(feature)
              "
              tooltipPosition="right"
              tooltipEvent="both"
            >
              @if (feature.id === 205) {
                <img
                  src="assets/file-icons/kb-sds-100.png"
                  alt=""
                  aria-hidden="true"
                  class="group link-item-icon link-item-icon-img"
                />
              } @else {
                <span
                  class="group link-item-icon icon ic-md icon-{{
                    feature.key | lowercase
                  }}"
                  aria-hidden="true"
                ></span>
              }
              <span class="link-item-txt">{{
                navLabelKey(feature) | translate
              }}</span>
              @if (
                navigation.expanded() &&
                !navigation.mobile() &&
                subNavigationFor(feature)
              ) {
                <i
                  class="pi pi-angle-right link-item-chevron"
                  aria-hidden="true"
                ></i>
              }
            </a>
          </li>
        }
      </ul>
    }
  </nav>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="!!subNavigation()"
    [cdkConnectedOverlayOrigin]="subNavigation()?.origin!"
    [cdkConnectedOverlayPositions]="subNavigationPositions"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="8"
    [cdkConnectedOverlayDisableClose]="true"
    (overlayOutsideClick)="closeSubNavigation()"
    (detach)="closeSubNavigation()"
  >
    @if (subNavigation(); as open) {
      <sub-navigation-panel
        [feature]="open.feature"
        [menu]="open.menu"
        [urlBase]="urlBase"
        [label]="navLabelKey(open.feature)"
        (navigated)="onSubNavigationNavigated(open.feature)"
        (dismissed)="closeSubNavigation(true)"
        (mouseenter)="cancelSubNavigationClose()"
        (mouseleave)="scheduleSubNavigationClose()"
        (focusout)="onSubNavigationFocusOut($event)"
      />
    }
  </ng-template>
</div>
@if (navigation.mobileOpen()) {
  <button
    class="kuba-nav-backdrop"
    type="button"
    tabindex="-1"
    [attr.aria-label]="'CLOSE' | translate"
    (click)="navigation.closeMobile()"
  ></button>
}
